// extracted by mini-css-extract-plugin
module.exports = {"container":"slogon_container__ZWlbO"};